/**
 * countdown2 ショートコード v2 用ランタイム
 *
 * 対象: .countdown.countdown--v2 (PHP 側で SSR 済み)
 * 役割: 1 秒ごとに残り時間と進捗バー、緊急度クラスを更新する。
 *
 * 設計メモ:
 * - jQuery 非依存 (vanilla)
 * - v1 (.countdown:not(.countdown--v2)) は assets/js/countdown.js が引き続き担当する
 * - SSR 済みのため、初回描画では DOM を書き換えず、次の tick から差分更新する
 * - 全カウントダウンを 1 本の setInterval で回す (タブ数増加でもタイマ膨張しない)
 * - prefers-reduced-motion 環境では progress バーの transition も切る
 */

(function () {
  'use strict';

  var SELECTOR = '.countdown.countdown--v2';
  var INITED_ATTR = 'data-countdown-v2-inited';
  var THRESHOLD_DANGER_SEC  = 24 * 60 * 60;        // 24 時間
  var THRESHOLD_WARNING_SEC = 3 * 24 * 60 * 60;    // 3 日
  var TICK_MS = 1000;

  var registry = [];
  var timerId = null;

  function nowSec() { return Math.floor(Date.now() / 1000); }

  function pad2(n) { return n < 10 ? '0' + n : '' + n; }

  function formatAriaLabel(days, hours, mins, secs) {
    return '残り ' + days + '日 ' + hours + '時間 ' + mins + '分 ' + secs + '秒';
  }

  function formatInlineText(days, hours, mins, secs) {
    var parts = [];
    if (days > 0) parts.push(days + '日');
    if (days > 0 || hours > 0) parts.push(hours + '時間');
    if (days === 0) parts.push(mins + '分');
    if (days === 0 && hours === 0) parts.push(secs + '秒');
    return parts.join(' ');
  }

  function urgencyClass(remainingSec) {
    if (remainingSec <= THRESHOLD_DANGER_SEC)  return 'is-danger';
    if (remainingSec <= THRESHOLD_WARNING_SEC) return 'is-warning';
    return '';
  }

  function setUrgency(el, cls) {
    el.classList.remove('is-warning', 'is-danger');
    if (cls) el.classList.add(cls);
  }

  function setValue(el, selector, text) {
    var node = el.querySelector(selector);
    if (node && node.textContent !== text) node.textContent = text;
  }

  function tickOne(state) {
    var el = state.el;
    if (!el || !el.isConnected) {
      state.done = true;
      return;
    }

    var startSec = state.startSec;
    var closeSec = state.closeSec;
    var now = nowSec();

    // 開始前: hidden を維持
    if (startSec > 0 && now < startSec) {
      if (!el.hasAttribute('hidden')) el.setAttribute('hidden', '');
      return;
    }
    if (el.hasAttribute('hidden')) el.removeAttribute('hidden');

    var remaining = closeSec - now;

    // 終了
    if (remaining <= 0) {
      if (!el.classList.contains('is-ended')) {
        el.classList.remove('is-warning', 'is-danger');
        el.classList.add('is-ended');
        el.setAttribute('aria-label', '終了済み');

        // close-message が空 (SSR 時に close_message 未指定) なら、
        // data-close-message のフォールバックを当てて表示する
        var closeEl = el.querySelector('.countdown-v2__close-message');
        if (closeEl) {
          var ssrText = (closeEl.textContent || '').trim();
          var fallback = el.getAttribute('data-close-message') || '終了しました';
          if (ssrText === '') closeEl.textContent = fallback;
        }
      }
      // 終了後の登録解除
      state.done = true;
      return;
    }

    var days  = Math.floor(remaining / 86400);
    var hours = Math.floor((remaining % 86400) / 3600);
    var mins  = Math.floor((remaining % 3600) / 60);
    var secs  = Math.floor(remaining % 60);

    setUrgency(el, urgencyClass(remaining));

    // 値更新 (差分のみ)
    if (state.isInline) {
      var inlineNode = el.querySelector('.countdown-v2__inline-text');
      if (inlineNode) {
        var txt = formatInlineText(days, hours, mins, secs);
        if (inlineNode.textContent !== txt) inlineNode.textContent = txt;
      }
    } else {
      setValue(el, '.countdown-v2__value[data-unit="days"]',  pad2(days));
      setValue(el, '.countdown-v2__value[data-unit="hours"]', pad2(hours));
      setValue(el, '.countdown-v2__value[data-unit="mins"]',  pad2(mins));
      setValue(el, '.countdown-v2__value[data-unit="secs"]',  pad2(secs));

      // 進捗バー
      if (startSec > 0 && closeSec > startSec) {
        var total = closeSec - startSec;
        var elapsed = Math.max(0, Math.min(total, now - startSec));
        var pct = (elapsed / total) * 100;
        var bar = el.querySelector('.countdown-v2__progress-bar');
        if (bar) bar.style.width = pct.toFixed(2) + '%';
      }
    }

    // aria-label の更新 (毎秒ではなく値が変わったときだけ)
    var nextLabel = formatAriaLabel(days, hours, mins, secs);
    if (state.lastAriaLabel !== nextLabel) {
      el.setAttribute('aria-label', nextLabel);
      state.lastAriaLabel = nextLabel;
    }
  }

  function tickAll() {
    var i = registry.length;
    while (i--) {
      var s = registry[i];
      try {
        tickOne(s);
      } catch (e) {
        // 個別エラーは握り潰して全体は止めない
      }
      if (s.done) registry.splice(i, 1);
    }
    if (registry.length === 0 && timerId !== null) {
      clearInterval(timerId);
      timerId = null;
    }
  }

  function ensureTimer() {
    if (timerId === null && registry.length > 0) {
      timerId = setInterval(tickAll, TICK_MS);
    }
  }

  function register(el) {
    if (!el || el.getAttribute(INITED_ATTR) === '1') return;
    el.setAttribute(INITED_ATTR, '1');

    var startSec = parseInt(el.getAttribute('data-start-time'), 10) || 0;
    var closeSec = parseInt(el.getAttribute('data-close-time'), 10) || 0;
    if (closeSec <= 0) return;

    registry.push({
      el: el,
      startSec: startSec,
      closeSec: closeSec,
      isInline: el.classList.contains('countdown--inline'),
      done: false,
      lastAriaLabel: el.getAttribute('aria-label') || ''
    });
    ensureTimer();
  }

  function scan(scope) {
    var root = scope || document;
    var list = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) register(list[i]);
  }

  // 初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // pjax 等で動的に DOM が増えるケース用に公開
  window.MokoCountdownV2 = { scan: scan };
})();
